export const linkPath = "https://grio.com"

export default {
  linkPath,
}
